// @flow
import { authenticatedFetch } from '../../api/request';

const getBraintreeClientToken = async () => {
    return await authenticatedFetch('/1.0/user/payment/token');
};

export default getBraintreeClientToken;
